import loadable from '@loadable/component';

export const CmsAnchorBlockLoadable = loadable(
  () => import('./CmsAnchorBlock'),
  { resolveComponent: (module) => module.CmsAnchorBlock },
);
